module.exports = __webpack_public_path__ + "img/logro5.7278bab5.webp";